import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { processLogin } from './loginActions';
import { LoginState, LoginResponseDTO, ExtendedEmployeeDTO } from 'types';

const initialState: LoginState = {
    loading: false,
    isOwner: false,
    isBasicEmployee: false,
    token: undefined,
    error: undefined,
    info: undefined,
    employee: undefined,
    expirationDate: undefined,
    expiredLogout: false,
};

const loginSlice = createSlice({
    name: 'login',
    initialState,
    reducers: {
        logout: (state: LoginState) => {
            state.loading = false;
            state.isBasicEmployee = false;
            state.isOwner = false;
            state.info = undefined;
            state.token = undefined;
            state.error = undefined;
            state.employee = undefined;
            state.expirationDate = undefined;
            state.expiredLogout = true;
        },
        setData: (state: LoginState, { payload }: PayloadAction<LoginResponseDTO>) => {
            state.error = undefined;
            state.info = payload;
            state.isOwner = payload.employee.role === 'OWNER';
            state.isBasicEmployee = payload.employee.role === 'EMPLOYEE';
            state.employee = payload.employee;
            state.token = payload.token;
            state.expiredLogout = false;
            state.expirationDate = new Date(new Date().getTime() + 24 * 60 * 60 * 1000);
        },
        updateEmployee: (state: LoginState, action: PayloadAction<ExtendedEmployeeDTO>) => {
            state.employee = action.payload;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(processLogin().pending, (state: LoginState) => {
                state.loading = true;
                state.error = undefined;
            })
            .addCase(processLogin().fulfilled, (state: LoginState, { payload }: PayloadAction<LoginResponseDTO>) => {
                state.loading = false;
            })
            .addCase(processLogin().rejected, (state: LoginState, action) => {
                state.loading = false;
                state.error = (action.payload as string) || action.error.message || '';
            });
    },
});

export const { logout, setData, updateEmployee } = loginSlice.actions;
export default loginSlice.reducer;
